import React, { Component } from 'react'
import ElementsDataService from '../../api/entitiesDataServices/ElementsDataService.js'
import AuthenticationService from '../general/AuthenticationService.js'

class DocumentoFormularioComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            id: this.props.match.params.id,
            tipoDocumento: '',
            asuntos: [],
            resumen: '',
            fecha: '',
            sociedades: [],
            entidades: [{ id: 1, nombres: [], roles: [], comentarios: '' }],
            allSociedades: [],
            entidadesArray: [],
            documentFileUrl: '',
            loading: false,
            errors: {},
            // búsqueda interna
            socSearch: '', showSocDrop: false,
            enteSearch: {}, showEnteDrop: {},
        }
        this.onSubmit = this.onSubmit.bind(this)
    }

    componentDidMount() {
        if (!AuthenticationService.haveAuthorization("WRITE_DOCUMENTOS")) {
            alert("Usuario no autorizado")
            this.props.history.push('/login')
            return
        }

        let entidadesArray = []
        ElementsDataService.retrieveAllElements("sociedades").then(r => {
            const socs = r.data.map(s => ({ id: s.id, razonSocial: s.razonSocial, rfc: s.rfc }))
            this.setState({ allSociedades: socs })
            socs.forEach(s => entidadesArray.push({ id: s.id, nombre: s.razonSocial, rfc: s.rfc, tipo: 'sociedad' }))
            return ElementsDataService.retrieveAllElements("personas-fisicas")
        }).then(r => {
            r.data.forEach(p => entidadesArray.push({
                id: p.id,
                nombre: `${p.nombre} ${p.apellidoPaterno} ${p.apellidoMaterno}`,
                rfc: p.rfc, tipo: 'personaFisica'
            }))
            this.setState({ entidadesArray })
        })

        if (Number(this.props.match.params.id) === -1) return

        ElementsDataService.retrieveElement("documentos", this.state.id).then(r => {
            const d = r.data
            const asuntosObjects = d.asuntos
                ? d.asuntos.split(',').map(a => asuntosData.find(x => x.nombre === a.trim())).filter(Boolean)
                : []
            const tipo = tipoDocumentoData.find(t => t.nombre === d.tipoDocumento) || null
            this.setState({
                tipoDocumento: tipo ? tipo.nombre : d.tipoDocumento || '',
                asuntos: asuntosObjects,
                resumen: d.resumen || '',
                documentFileUrl: d.documentFileUrl || '',
                sociedades: d.sociedades || [],
                entidades: JSON.parse(d.entidadesRolDocumento).data,
                fecha: d.fecha || '',
            })
        })
    }

    validate() {
        const { tipoDocumento, sociedades, fecha, documentFileUrl } = this.state
        const e = {}
        if (!tipoDocumento) e.tipoDocumento = 'Requerido'
        if (!sociedades.length) e.sociedades = 'Debe agregar al menos una sociedad'
        if (!fecha) e.fecha = 'Requerido'
        else { const y = new Date(fecha).getFullYear(); if (y < 1900 || y > 2100) e.fecha = 'Año inválido' }
        if (!documentFileUrl) e.documentFileUrl = 'Debe seleccionar el archivo del documento'
        this.setState({ errors: e })
        return Object.keys(e).length === 0
    }

    onSubmit() {
        if (!this.validate()) return
        this.setState({ loading: true })
        const { tipoDocumento, asuntos, resumen, sociedades, entidades, documentFileUrl, fecha } = this.state
        const fd = new FormData()
        fd.append('tipoDocumento', tipoDocumento)
        fd.append('asuntos', JSON.stringify({ data: asuntos }))
        fd.append('resumen', resumen)
        fd.append('sociedades', JSON.stringify({ data: sociedades }))
        fd.append('entidades', JSON.stringify({ data: entidades }))
        fd.append('documentoFile', documentFileUrl)
        fd.append('fecha', fecha)

        const ok = (r, msgOk) => {
            if (r.data.message === msgOk) {
                this.props.history.push(`/documentos/reportes/${r.data.id || this.state.id}`)
            } else {
                alert(r.data.message)
                this.setState({ loading: false })
            }
        }
        if (Number(this.state.id) === -1) {
            ElementsDataService.createElement("documentos", fd).then(r => ok(r, 'Created'))
        } else {
            ElementsDataService.updateElement("documentos", this.state.id, fd).then(r => ok(r, 'Updated'))
        }
    }

    addEnte() {
        const e = { id: this.state.entidades.length + 1, nombres: [], roles: [], comentarios: '' }
        this.setState({ entidades: [...this.state.entidades, e] })
    }

    removeEnte(id) {
        const arr = this.state.entidades.filter(e => e.id !== id).map((e, i) => ({ ...e, id: i + 1 }))
        this.setState({ entidades: arr })
    }

    updateEnte(id, key, value) {
        this.setState({ entidades: this.state.entidades.map(e => e.id === id ? { ...e, [key]: value } : e) })
    }

    render() {
        const { tipoDocumento, asuntos, resumen, sociedades, allSociedades, entidades,
            entidadesArray, documentFileUrl, fecha, loading, errors,
            socSearch, showSocDrop } = this.state
        const isNew = Number(this.state.id) === -1

        const filtSocs = allSociedades.filter(s =>
            !sociedades.find(x => x.rfc === s.rfc) &&
            (s.razonSocial + ' ' + s.rfc).toLowerCase().includes(socSearch.toLowerCase())
        )

        return (
            <div style={S.root}>
                <style>{css}</style>
                <div className="dff2-root" style={S.inner}>

                    {/* Header */}
                    <div style={S.header}>
                        <div>
                            <p style={S.breadcrumb}>
                                <span style={{ color: '#3b82f6', cursor: 'pointer' }} onClick={() => this.props.history.push('/documentos')}>Documentos</span>
                                <span style={{ margin: '0 8px', color: '#cbd5e1' }}>›</span>
                                <span>{isNew ? 'Nuevo' : 'Editar'}</span>
                            </p>
                            <h1 style={S.title}>{isNew ? 'Nuevo Documento' : 'Editar Documento'}</h1>
                        </div>
                        <div style={{ display: 'flex', gap: 10 }}>
                            <button className="btn-cancel" onClick={() => this.props.history.goBack()}>Cancelar</button>
                            <button className="btn-save" onClick={this.onSubmit} disabled={loading}>
                                {loading ? '⏳ Guardando...' : '✓ Guardar'}
                            </button>
                        </div>
                    </div>

                    {/* ── 1. Datos principales ── */}
                    <Section icon="📄" title="Datos del Documento">
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 160px', gap: 14, marginBottom: 14 }}>
                            <div>
                                <label className="dff2-label">Tipo de Documento *</label>
                                <select className={`dff2-select${errors.tipoDocumento ? ' err' : ''}`}
                                    value={tipoDocumento}
                                    onChange={e => this.setState({ tipoDocumento: e.target.value, errors: { ...errors, tipoDocumento: null } })}>
                                    <option value="">— Seleccionar —</option>
                                    {tipoDocumentoData.map(t => <option key={t.id} value={t.nombre}>{t.nombre}</option>)}
                                </select>
                                {errors.tipoDocumento && <p className="dff2-err">⚠ {errors.tipoDocumento}</p>}
                            </div>
                            <div>
                                <label className="dff2-label">Fecha *</label>
                                <input className={`dff2-input${errors.fecha ? ' err' : ''}`} type="date" value={fecha}
                                    onChange={e => this.setState({ fecha: e.target.value, errors: { ...errors, fecha: null } })} />
                                {errors.fecha && <p className="dff2-err">⚠ {errors.fecha}</p>}
                            </div>
                        </div>

                        {/* Asuntos — chips multi */}
                        <div style={{ marginBottom: 14 }}>
                            <label className="dff2-label">Asuntos</label>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 8 }}>
                                {asuntos.map(a => (
                                    <span key={a.id} className="chip-item">
                                        {a.nombre}
                                        <button type="button" onClick={() => this.setState({ asuntos: asuntos.filter(x => x.id !== a.id) })}>✕</button>
                                    </span>
                                ))}
                            </div>
                            <select className="dff2-select" value=""
                                onChange={e => {
                                    const found = asuntosData.find(x => String(x.id) === e.target.value)
                                    if (found && !asuntos.find(a => a.id === found.id)) this.setState({ asuntos: [...asuntos, found] })
                                }}>
                                <option value="">+ Agregar asunto...</option>
                                {asuntosData.filter(a => !asuntos.find(x => x.id === a.id)).map(a => (
                                    <option key={a.id} value={a.id}>{a.nombre}</option>
                                ))}
                            </select>
                        </div>

                        <div>
                            <label className="dff2-label">Resumen</label>
                            <textarea className="dff2-textarea" value={resumen} rows={3}
                                onChange={e => this.setState({ resumen: e.target.value })}
                                placeholder="Descripción o resumen del documento..." />
                        </div>
                    </Section>

                    {/* ── 2. Sociedades ── */}
                    <Section icon="🏢" title="Sociedades Vinculadas">
                        {sociedades.length > 0 && (
                            <div style={{ marginBottom: 12, display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                                {sociedades.map(s => (
                                    <span key={s.rfc || s.id} className="chip-item">
                                        {s.razonSocial}
                                        <button type="button" onClick={() => this.setState({ sociedades: sociedades.filter(x => (x.rfc || x.id) !== (s.rfc || s.id)) })}>✕</button>
                                    </span>
                                ))}
                            </div>
                        )}
                        <div style={{ position: 'relative' }}>
                            <span style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}>🔍</span>
                            <input className={`dff2-input${errors.sociedades ? ' err' : ''}`}
                                style={{ paddingLeft: 36 }}
                                type="text"
                                placeholder="Buscar sociedad por nombre o RFC..."
                                value={socSearch}
                                onChange={e => this.setState({ socSearch: e.target.value, showSocDrop: true })}
                                onFocus={() => this.setState({ showSocDrop: true })}
                                onBlur={() => setTimeout(() => this.setState({ showSocDrop: false }), 150)}
                            />
                            {showSocDrop && socSearch.length > 0 && (
                                <div className="dff2-dropdown">
                                    {filtSocs.length === 0
                                        ? <div style={{ padding: '10px 14px', color: '#94a3b8', fontSize: '0.8rem' }}>Sin resultados</div>
                                        : filtSocs.slice(0, 40).map(s => (
                                            <div key={s.id} className="dff2-drop-item"
                                                onMouseDown={() => this.setState({ sociedades: [...sociedades, s], socSearch: '', showSocDrop: false, errors: { ...errors, sociedades: null } })}>
                                                <span style={{ fontWeight: 600 }}>{s.razonSocial}</span>
                                                <span style={{ fontSize: '0.7rem', color: '#94a3b8', fontFamily: 'monospace', marginLeft: 8 }}>{s.rfc}</span>
                                            </div>
                                        ))
                                    }
                                </div>
                            )}
                        </div>
                        {errors.sociedades && <p className="dff2-err" style={{ marginTop: 6 }}>⚠ {errors.sociedades}</p>}
                    </Section>

                    {/* ── 3. Entes / Roles ── */}
                    <Section icon="👥" title="Entes y Roles">
                        <div style={{ overflowX: 'auto' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 640 }}>
                                <thead>
                                    <tr>
                                        <th className="dff2-th">Persona Física / Moral</th>
                                        <th className="dff2-th" style={{ width: 200 }}>Roles</th>
                                        <th className="dff2-th">Comentarios</th>
                                        <th className="dff2-th" style={{ width: 40 }}>
                                            <button type="button" className="btn-add-row" onClick={() => this.addEnte()} title="Agregar fila">＋</button>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {entidades.map(ente => (
                                        <EnteRow
                                            key={ente.id}
                                            ente={ente}
                                            entidadesArray={entidadesArray}
                                            onUpdateNombres={v => this.updateEnte(ente.id, 'nombres', v)}
                                            onUpdateRoles={v => this.updateEnte(ente.id, 'roles', v)}
                                            onUpdateComentarios={v => this.updateEnte(ente.id, 'comentarios', v)}
                                            onRemove={() => this.removeEnte(ente.id)}
                                        />
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Section>

                    {/* ── 4. Archivo ── */}
                    <Section icon="📎" title="Archivo del Documento">
                        <div>
                            <label className="dff2-label">Documento PDF / Archivo *</label>
                            <div className={`dff2-file-zone${errors.documentFileUrl ? ' err' : ''}`}
                                onClick={() => document.getElementById('doc-file-input').click()}>
                                <span style={{ fontSize: '1.3rem' }}>📁</span>
                                <div>
                                    <p style={{ margin: 0, fontSize: '0.85rem', fontWeight: 600, color: documentFileUrl && documentFileUrl.name ? '#3b82f6' : '#475569' }}>
                                        {documentFileUrl && documentFileUrl.name
                                            ? documentFileUrl.name
                                            : documentFileUrl && typeof documentFileUrl === 'string' && documentFileUrl.startsWith('http')
                                                ? '📄 Archivo cargado — click para reemplazar'
                                                : 'Seleccionar archivo...'}
                                    </p>
                                    <p style={{ margin: '2px 0 0', fontSize: '0.72rem', color: '#94a3b8' }}>PDF, DOC, DOCX, JPG, PNG</p>
                                </div>
                                {documentFileUrl && typeof documentFileUrl === 'string' && documentFileUrl.startsWith('http') && (
                                    <a href={documentFileUrl} target="_blank" rel="noopener noreferrer"
                                        style={{ marginLeft: 'auto', fontSize: '0.78rem', color: '#3b82f6', textDecoration: 'none', whiteSpace: 'nowrap' }}
                                        onClick={e => e.stopPropagation()}>
                                        Ver actual ↗
                                    </a>
                                )}
                            </div>
                            <input id="doc-file-input" type="file" style={{ display: 'none' }}
                                onChange={e => e.currentTarget.files[0] && this.setState({ documentFileUrl: e.currentTarget.files[0], errors: { ...errors, documentFileUrl: null } })} />
                            {errors.documentFileUrl && <p className="dff2-err" style={{ marginTop: 6 }}>⚠ {errors.documentFileUrl}</p>}
                        </div>
                    </Section>

                    {/* Footer */}
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginBottom: 24 }}>
                        <button type="button" className="btn-cancel" onClick={() => this.props.history.goBack()}>Cancelar</button>
                        <button type="button" className="btn-save" onClick={this.onSubmit} disabled={loading}>
                            {loading ? '⏳ Guardando...' : '✓ Guardar Documento'}
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

/* ── EnteRow ── */
class EnteRow extends Component {
    constructor(props) {
        super(props)
        this.state = { enteSearch: '', showEnteDrop: false }
    }
    render() {
        const { ente, entidadesArray, onUpdateNombres, onUpdateRoles, onUpdateComentarios, onRemove } = this.props
        const { enteSearch, showEnteDrop } = this.state
        const filtEntes = entidadesArray.filter(e =>
            !ente.nombres.find(n => n.id === e.id) &&
            (e.nombre + ' ' + e.rfc).toLowerCase().includes(enteSearch.toLowerCase())
        )
        return (
            <tr style={{ borderBottom: '1px solid #f1f5f9' }}>
                {/* Persona/Moral */}
                <td style={{ padding: '10px 12px', verticalAlign: 'top' }}>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginBottom: 6 }}>
                        {ente.nombres.map(n => (
                            <span key={n.id} className="chip-mini">
                                <span style={{ fontSize: '0.65rem', color: n.tipo === 'sociedad' ? '#2563eb' : '#7c3aed', marginRight: 3 }}>
                                    {n.tipo === 'sociedad' ? '🏢' : '👤'}
                                </span>
                                {n.nombre}
                                <button type="button" onClick={() => onUpdateNombres(ente.nombres.filter(x => x.id !== n.id))}>✕</button>
                            </span>
                        ))}
                    </div>
                    <div style={{ position: 'relative' }}>
                        <input className="dff2-input-sm"
                            type="text" placeholder="Buscar ente..."
                            value={enteSearch}
                            onChange={e => this.setState({ enteSearch: e.target.value, showEnteDrop: true })}
                            onFocus={() => this.setState({ showEnteDrop: true })}
                            onBlur={() => setTimeout(() => this.setState({ showEnteDrop: false }), 150)}
                        />
                        {showEnteDrop && enteSearch.length > 0 && (
                            <div className="dff2-dropdown">
                                {filtEntes.length === 0
                                    ? <div style={{ padding: '8px 12px', color: '#94a3b8', fontSize: '0.78rem' }}>Sin resultados</div>
                                    : filtEntes.slice(0, 20).map(e => (
                                        <div key={e.id} className="dff2-drop-item"
                                            onMouseDown={() => { onUpdateNombres([...ente.nombres, e]); this.setState({ enteSearch: '', showEnteDrop: false }) }}>
                                            <span style={{ marginRight: 6 }}>{e.tipo === 'sociedad' ? '🏢' : '👤'}</span>
                                            <span style={{ fontWeight: 600 }}>{e.nombre}</span>
                                            <span style={{ fontSize: '0.68rem', color: '#94a3b8', marginLeft: 6 }}>{e.rfc}</span>
                                        </div>
                                    ))
                                }
                            </div>
                        )}
                    </div>
                </td>
                {/* Roles */}
                <td style={{ padding: '10px 12px', verticalAlign: 'top' }}>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginBottom: 6 }}>
                        {ente.roles.map(r => (
                            <span key={r.id} className="chip-mini chip-purple">
                                {r.nombre}
                                <button type="button" onClick={() => onUpdateRoles(ente.roles.filter(x => x.id !== r.id))}>✕</button>
                            </span>
                        ))}
                    </div>
                    <select className="dff2-input-sm" style={{ appearance: 'none', backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 12 12'%3E%3Cpath fill='%2394a3b8' d='M6 8L1 3h10z'/%3E%3C/svg%3E\")", backgroundRepeat: 'no-repeat', backgroundPosition: 'right 8px center', paddingRight: 24 }}
                        value=""
                        onChange={e => {
                            const found = rolesData.find(r => String(r.id) === e.target.value)
                            if (found && !ente.roles.find(r => r.id === found.id)) onUpdateRoles([...ente.roles, found])
                        }}>
                        <option value="">+ Rol...</option>
                        {rolesData.filter(r => !ente.roles.find(x => x.id === r.id)).map(r => (
                            <option key={r.id} value={r.id}>{r.nombre}</option>
                        ))}
                    </select>
                </td>
                {/* Comentarios */}
                <td style={{ padding: '10px 12px', verticalAlign: 'top' }}>
                    <textarea className="dff2-textarea" style={{ minHeight: 60, fontSize: '0.8rem' }}
                        value={ente.comentarios}
                        onChange={e => onUpdateComentarios(e.target.value)}
                        placeholder="Comentarios..." />
                </td>
                {/* Eliminar */}
                <td style={{ padding: '10px 8px', textAlign: 'center', verticalAlign: 'top' }}>
                    <button type="button" className="btn-del-row" onClick={onRemove} title="Eliminar fila">🗑</button>
                </td>
            </tr>
        )
    }
}

/* ── helpers ── */
const Section = ({ icon, title, children }) => (
    <div style={{ background: 'white', border: '1px solid #e8edf5', borderRadius: 16, marginBottom: 14, overflow: 'visible', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '13px 22px', borderBottom: '1px solid #f1f5f9', background: '#fafcff' }}>
            <span>{icon}</span>
            <h2 style={{ margin: 0, fontSize: '0.9rem', fontWeight: 700, color: '#1e293b' }}>{title}</h2>
        </div>
        <div style={{ padding: '18px 22px' }}>{children}</div>
    </div>
)

const css = `
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
    .dff2-root * { font-family: 'Inter', sans-serif; box-sizing: border-box; }
    .dff2-label { font-size: 0.68rem; font-weight: 700; color: #64748b; letter-spacing: 0.8px; text-transform: uppercase; display: block; margin-bottom: 5px; }
    .dff2-input {
        width: 100%; padding: 9px 13px; background: white; border: 1px solid #e2e8f0;
        border-radius: 10px; font-size: 0.875rem; color: #1e293b; outline: none;
        transition: all 0.2s; font-family: 'Inter', sans-serif;
    }
    .dff2-input:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,0.1); }
    .dff2-input.err { border-color: #ef4444; }
    .dff2-input-sm {
        width: 100%; padding: 7px 11px; background: #f8fafc; border: 1px solid #e2e8f0;
        border-radius: 8px; font-size: 0.8rem; color: #334155; outline: none;
        transition: all 0.2s; font-family: 'Inter', sans-serif;
    }
    .dff2-input-sm:focus { border-color: #3b82f6; background: white; box-shadow: 0 0 0 2px rgba(59,130,246,0.1); }
    .dff2-select {
        width: 100%; padding: 9px 32px 9px 13px; appearance: none; background: white;
        border: 1px solid #e2e8f0; border-radius: 10px; font-size: 0.875rem; color: #1e293b;
        outline: none; cursor: pointer; transition: all 0.2s; font-family: 'Inter', sans-serif;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 12 12'%3E%3Cpath fill='%2394a3b8' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
        background-repeat: no-repeat; background-position: right 11px center;
    }
    .dff2-select:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,0.1); }
    .dff2-select.err { border-color: #ef4444; }
    .dff2-textarea {
        width: 100%; padding: 9px 13px; min-height: 80px; resize: vertical; background: white;
        border: 1px solid #e2e8f0; border-radius: 10px; font-size: 0.875rem; color: #1e293b;
        outline: none; transition: all 0.2s; font-family: 'Inter', sans-serif; line-height: 1.6;
    }
    .dff2-textarea:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,0.1); }
    .dff2-err { font-size: 0.72rem; color: #ef4444; margin-top: 4px; }
    .dff2-th { padding: 9px 12px; text-align: left; font-size: 0.68rem; font-weight: 700; color: #64748b; letter-spacing: 0.7px; text-transform: uppercase; border-bottom: 2px solid #e2e8f0; background: #f8fafc; }
    .dff2-dropdown {
        position: absolute; top: calc(100% + 4px); left: 0; right: 0;
        background: white; border: 1px solid #e2e8f0; border-radius: 10px;
        z-index: 200; max-height: 200px; overflow-y: auto;
        box-shadow: 0 8px 24px rgba(0,0,0,0.1);
    }
    .dff2-drop-item { padding: 9px 14px; cursor: pointer; font-size: 0.82rem; color: #334155; transition: background 0.12s; }
    .dff2-drop-item:hover { background: #eff6ff; color: #2563eb; }
    .chip-item {
        display: inline-flex; align-items: center; gap: 5px;
        background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 20px;
        padding: 3px 10px 3px 10px; font-size: 0.75rem; color: #2563eb; font-weight: 600;
    }
    .chip-item button { background: #bfdbfe; border: none; border-radius: 50%; width: 15px; height: 15px; cursor: pointer; font-size: 0.55rem; color: #1d4ed8; display: flex; align-items: center; justify-content: center; }
    .chip-item button:hover { background: #ef4444; color: white; }
    .chip-mini {
        display: inline-flex; align-items: center; gap: 4px;
        background: #f0f9ff; border: 1px solid #bae6fd; border-radius: 12px;
        padding: 2px 8px; font-size: 0.72rem; color: #0369a1;
    }
    .chip-mini.chip-purple { background: #f5f3ff; border-color: #ddd6fe; color: #7c3aed; }
    .chip-mini button { background: none; border: none; cursor: pointer; color: #94a3b8; font-size: 0.6rem; padding: 0; line-height: 1; }
    .chip-mini button:hover { color: #ef4444; }
    .dff2-file-zone {
        display: flex; align-items: center; gap: 14px;
        border: 1.5px dashed #e2e8f0; border-radius: 12px; padding: 16px 18px;
        background: #f8fafc; cursor: pointer; transition: all 0.2s;
    }
    .dff2-file-zone:hover { border-color: #3b82f6; background: #eff6ff; }
    .dff2-file-zone.err { border-color: #ef4444; }
    .btn-save { padding: 11px 28px; background: linear-gradient(135deg, #2563eb, #3b82f6); border: none; border-radius: 10px; color: white; font-weight: 700; font-size: 0.88rem; cursor: pointer; transition: all 0.2s; font-family: 'Inter', sans-serif; box-shadow: 0 4px 14px rgba(59,130,246,0.3); }
    .btn-save:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 6px 18px rgba(59,130,246,0.4); }
    .btn-save:disabled { opacity: 0.6; cursor: not-allowed; }
    .btn-cancel { padding: 11px 20px; background: white; border: 1px solid #e2e8f0; border-radius: 10px; color: #64748b; font-weight: 600; font-size: 0.88rem; cursor: pointer; transition: all 0.2s; font-family: 'Inter', sans-serif; }
    .btn-cancel:hover { border-color: #94a3b8; color: #334155; }
    .btn-add-row { background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 7px; color: #2563eb; font-size: 1rem; width: 28px; height: 28px; cursor: pointer; display: flex; align-items: center; justify-content: center; }
    .btn-add-row:hover { background: #2563eb; color: white; }
    .btn-del-row { background: none; border: 1px solid #fee2e2; border-radius: 7px; color: #ef4444; font-size: 0.8rem; padding: 3px 7px; cursor: pointer; }
    .btn-del-row:hover { background: #fef2f2; }
`

const S = {
    root: { minHeight: '100vh', background: '#f1f5f9', padding: '28px', fontFamily: "'Inter', sans-serif" },
    inner: { maxWidth: 980, margin: '0 auto' },
    header: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 20, flexWrap: 'wrap', gap: 12 },
    breadcrumb: { margin: '0 0 4px', fontSize: '0.78rem', color: '#94a3b8' },
    title: { margin: 0, fontSize: '1.45rem', fontWeight: 700, color: '#0f172a' },
}

/* ── Catálogos ── */
const tipoDocumentoData = [
    { id: 1, nombre: 'Asamblea Ordinaria' }, { id: 2, nombre: 'Asamblea Extraordinaria' },
    { id: 3, nombre: 'Asamblea Constitutiva' }, { id: 4, nombre: 'Asamblea Mixta' },
    { id: 5, nombre: 'Mandato' }, { id: 6, nombre: 'CIF' },
    { id: 7, nombre: 'Acuse de cambio de domicilio' }, { id: 8, nombre: 'Acuse FIEL' },
    { id: 9, nombre: 'Solicitud de certificado e firma' },
    { id: 10, nombre: 'Carta responsiva para generar los archivos .req y/o .ren' },
    { id: 11, nombre: 'Acuse de movimientos de actualización de situación fiscal' },
    { id: 12, nombre: 'Otro' },
]
const asuntosData = [
    { id: 1, nombre: 'Constitutiva' }, { id: 2, nombre: 'Nombramiento Administrador/Consejo de Administración' },
    { id: 3, nombre: 'Determinacion Emolumentos' }, { id: 4, nombre: 'Prórroga de la duración de la sociedad' },
    { id: 5, nombre: 'Disolución anticipada de la sociedad' }, { id: 6, nombre: 'Aumento o reducción del capital social' },
    { id: 7, nombre: 'Cambio de objeto de la sociedad' }, { id: 8, nombre: 'Cambio de nacionalidad de la sociedad' },
    { id: 9, nombre: 'Transformación de la sociedad' }, { id: 10, nombre: 'Fusión con otra sociedad' },
    { id: 11, nombre: 'Emisión de acciones privilegiadas' },
    { id: 12, nombre: 'Amortización por la sociedad de sus propias acciones y emisión de acciones de goce' },
    { id: 13, nombre: 'Emisión de bonos' }, { id: 14, nombre: 'Cualquiera otra modificación del contrato social' },
    { id: 15, nombre: 'Otorgamiento de Poder' }, { id: 16, nombre: 'Revocación' },
    { id: 17, nombre: 'Aprobación de algún otro Jurídico' }, { id: 18, nombre: 'Compra venta de acciones/partes sociales' },
    { id: 19, nombre: 'Cambio de Domicilio Social' }, { id: 20, nombre: 'Cambio de Domicilio Fiscal' },
    { id: 21, nombre: 'Cambio de Denominación' }, { id: 22, nombre: 'Admisión/Renuncia de Asociados' },
    { id: 23, nombre: 'Otro' },
]
const rolesData = [
    { id: 1, nombre: 'Socio' }, { id: 2, nombre: 'Accionista' }, { id: 3, nombre: 'Asociado' },
    { id: 4, nombre: 'Comisario' }, { id: 5, nombre: 'Administrador General Único' },
    { id: 6, nombre: 'Poderdante' }, { id: 7, nombre: 'Apoderado' },
    { id: 8, nombre: 'Presidente Consejo Administración' }, { id: 9, nombre: 'Delegado Especial' },
    { id: 10, nombre: 'Socio Administrador' }, { id: 11, nombre: 'Escrutador' },
    { id: 12, nombre: 'Gerente' }, { id: 13, nombre: 'Director General' }, { id: 15, nombre: 'Otro' },
]

export default DocumentoFormularioComponent
